// eslint-disable-next-line import/no-unresolved
import ApiSearchResponse from 'prismic-javascript/types/ApiSearchResponse'

export const prismicHomePageContent: ApiSearchResponse = {
  page: 1,
  results_per_page: 20,
  results_size: 2,
  total_results_size: 2,
  total_pages: 1,
  next_page: 'null',
  prev_page: 'null',
  results: [
    {
      id: 'Xvyn1REAACMAsLcN',
      uid: 'null',
      type: 'home_page_updates',
      href: 'https://world-community-grid.cdn.prismic.io/api/v2/documents/search?ref=X_XcGxEAACMAsRlP&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22Xvyn1REAACMAsLcN%22%29+%5D%5D',
      tags: [],
      first_publication_date: '2020-07-01T15:12:26+0000',
      last_publication_date: '2021-01-06T15:49:47+0000',
      slugs: ['africa-rainfall-project-makes-plans-for-data-storing-and-sharing', 'this-is-how-a-global-community-unites-to-find-cancer-biomarkers.'],
      lang: 'en-us',
      alternate_languages: [],
      data: {
        body: [
          {
            primary: {
              subject: 'ARP1 Restarted (October 2024)',
              summary: 'The ARP project has sent new workunits to volunteers, and will restart fully by Monday November 4, 2024',
              date: '2024-10-31',
              image: {
                url: 'https://www.worldcommunitygrid.org/images/prismic/arp1_restart_wudist_only.jpg',
              },
              link: 'https://www.worldcommunitygrid.org/about_us/article.s?articleId=814',
            },
          },
          {
            primary: {
              subject: 'Research update from the MCM team (July 2024)',
              summary: 'ASTN2, a protein involved in neuronal migration, is expressed across several tissue types and has been implicated in various cancers.',
              date: '2024-07-10',
              image: {
                url: 'https://lh7-us.googleusercontent.com/docsz/AD_4nXfIo95JIMTUlgWsv0hLqr9uURS55NCsFA-2E2Hfaj9Eixogo7Xs-7hUUw0uVLxkuO_Ose9fL_2lQwDH0hW2DkXNTGlqJY99OX5sP_tSaUvjxvFIvsOwYMZOQanlre75yR5IOKjGLexb5pMzQgfQwYJ5Uf7b?key=d8OOdwoCe5jn1aSnJrNIIQ',
              },
              link: 'https://www.worldcommunitygrid.org/about_us/article.s?articleId=813',
            },
          },
          {
            primary: {
              subject: 'Research Update from the OPN Team (February 2024)',
              summary: 'New work units targeting the DNA polymerase of cytomegalovirus.',
              date: '2024-02-14',
              image: {
                url: 'https://lh7-us.googleusercontent.com/8YFL_jgxtB7LPXDIjdvJOTZcq2BzT5Kxj3YN8BnZi9r5zmBSJr2qzh3M2jKA25JEpIOelLzAvuFFjDSeXuidfAe6nJKlKImFV40MxJGUEsAhWigvwb6tLno9CfUcgWSgZ1SjpEehTyp64Uqi8cQ5vF8',
              },
              link: 'https://www.worldcommunitygrid.org/about_us/article.s?articleId=806',
            },
          },
        ],
      },
    },
    {
      id: 'Xvu1qxEAACMArIvY',
      uid: 'null',
      type: 'home_page_hero',
      href: 'https://world-community-grid.cdn.prismic.io/api/v2/documents/search?ref=X_XcGxEAACMAsRlP&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22Xvu1qxEAACMArIvY%22%29+%5D%5D',
      tags: [],
      first_publication_date: '2020-06-30T22:02:11+0000',
      last_publication_date: '2021-01-05T19:32:17+0000',
      slugs: ['home--world-community-grid', 'kevin--home--world-community-grid', 'aids-is-constantly-evolving.so-are-the-tools-to-fight-it.'],
      lang: 'en-us',
      alternate_languages: [],
      data: {
        page_title: 'Home | World Community Grid',
        page_description:
          'World Community Grid enables anyone with a computer or Android device to donate their unused computing power to advance cutting-edge scientific research on topics related to health and sustainability.',
        social_image: '/images/logo_images/wcg_logo_square_new_200x200.png',
        background_image: {
          url: '/images/prismic/transitionBig.jpg',
        },
        headline: [
          {
            type: 'paragraph',
            text: 'Celebrating 19 years of World Community Grid',
            spans: [],
          },
          {
            type: 'paragraph',
            text: '',
            spans: [],
          },
        ],
        summary: 'Accelerating science by creating a supercomputer empowered by a global community of volunteers.',
        text_color: 'White',
        image_overlay_style: 'None',
        body: [
          {
            slice_type: 'learn_more',
            primary: {
              link: 'https://www.worldcommunitygrid.org/about_us/viewNewsArticle.do?articleId=757',
            },
          },
          /* prettier-ignore */
          /* This enables the "join" a project button on the home page, uncomment to add it back
          {
            slice_type: 'contribute_link',
            primary: {
              project_short_name: 'opn1',
            },
          },*/
        ],
      },
    },
  ],
}
